import { render, staticRenderFns } from "./DepositMessageDetails.vue?vue&type=template&id=2a2b59dd&"
import script from "./DepositMessageDetails.vue?vue&type=script&lang=js&"
export * from "./DepositMessageDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports